import React from "react";
import { Link } from "gatsby";
import Anchor from "react-anchor-link-smooth-scroll";

export default ({ children, to, anchorLink, caps, openInNewTab, ...props }) => {
	// first, see if to is undefined (this is for cards that link but cause onClick action instead)
	if (to === undefined && !anchorLink) {
		return <span {...props}>{children}</span>;
	}

	// then, check to see if is a link to home page:
	const homePageLink = to === "/";
	// then, see if to is slug (with no slashes):
	const isSlug = /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(to);
	if (isSlug) {
		to = `/${to}/`;
	}
	// next, test to see if 'www.submittable.com' is at the beginning of the link, then strip the slug:
	const containsWWW = /^http(|s)\:\/\/www\.submittable\.com/.test(to);
	// make sure we're not directly linking to assets (.pdf, .doc, etc.)
	const isFile = /.+\.(pdf|mp3|mp4|doc|png)$/.test(to);
	if (containsWWW && !isFile) {
		to = to.slice(to.indexOf(".com") + 4, to.length);
	}
	// next, test to see if there is no trailing slash:
	if (
		!isFile &&
		to[0] === "/" &&
		to[to.length - 1] !== "/" &&
		to.indexOf("#") < 0 &&
		to.indexOf("?") < 0
	) {
		to = `${to}/`;
	}
	// finally test if above treatment has turned it into an internal link:
	const isInternalLink =
		homePageLink || (to.indexOf("#") > 0 && to[0] === "/") || /^\/.*\/$/.test(to);

	// add url parameters if they exist:
	if (typeof window !== "undefined") {
		if (window.location.search && isInternalLink) {
			to = `${to}${window.location.search}`;
		}
	}
	if (anchorLink) {
		return (
			<Anchor href={anchorLink} offset={props.offset || 100} caps={caps ? 1 : 0} {...props}>
				{children}
			</Anchor>
		);
	}
	if (isInternalLink && !openInNewTab) {
		return (
			<Link to={to} caps={caps ? 1 : 0} {...props}>
				{children}
			</Link>
		);
	}
	return (
		<Link href={to} target="_blank" rel="noopener noreferrer" caps={caps ? 1 : 0} {...props}>
			{children}
		</Link>
	);
};
